import type { IconData } from '@stacksjs/iconify-core'

export const beautyHealthyFoodDish: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 3.05H32v7.62h-1.52Zm-1.52 7.62h1.52v1.52h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.53 10.66h1.53v18.29h-1.53Zm0-7.62h1.53v3.05h-1.53Zm-1.52 25.91h1.52V32h-1.52Zm0-27.43h1.52v1.52h-1.52ZM24.39 0h4.57v1.53h-4.57Zm0 12.19h1.52v18.29h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm0-9.14h1.53v1.52h-1.53Zm-1.52 1.52h1.52v7.62h-1.52Zm-1.53 25.91h3.05v1.52h-3.05Zm-10.66-6.1h4.57v4.57h4.57v-4.57h4.57v-4.57h-4.57v-4.57h-4.57v4.57H9.15zm3.05 7.62h7.61V32H12.2Zm0-21.33h7.61v1.52H12.2ZM9.15 28.96h3.05v1.52H9.15ZM9.15 0h1.52v10.67H9.15ZM7.62 10.67h1.53v1.52H7.62ZM6.1 12.19h1.52v18.29H6.1ZM6.1 0h1.52v9.15H6.1ZM4.58 30.48H6.1V32H4.58ZM3.05 12.19h1.53v18.29H3.05ZM3.05 0h1.53v9.15H3.05ZM1.53 10.67h1.52v1.52H1.53ZM0 0h1.53v10.67H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default beautyHealthyFoodDish
